import { toggle } from "@otto-ec/global-resources/toggle";
import {
  catchFailure,
  flatMap,
  fromCondition,
  fromNullable,
  map,
  pipe,
  succeed,
  trySyncImmediate,
  mapError,
  pipeMap,
} from "@otto-ec/assets-core-utils/nano-effect";
import { onLoad } from "@otto-ec/global-resources/dom";
import { sheetScope } from "./utils";
import { create } from "../SheetV1.api";
import type { OcSheetV1Props } from "../SheetV1.types.g";
import { next } from "./sheetHistory";

const QUERY_PARAM_NAME = "oc-sheet-v1";
const log = /*           */ sheetScope.scope("query-param");

export function initQueryParams(): void {
  pipe(
    /*                                      */
    fromNullable(new URLSearchParams(window.location.search).get(QUERY_PARAM_NAME)),

    /*                                      */
    flatMap((maybeB64Encoded) =>
      pipe(
        trySyncImmediate(() => atob(maybeB64Encoded)),
        catchFailure(() => succeed(maybeB64Encoded)),
      ),
    ),

    /*                           */
    flatMap((maybeJson) =>
      pipe(
        trySyncImmediate(() => JSON.parse<OcSheetV1Props>(maybeJson)),
        catchFailure(() => succeed(maybeJson)),
      ),
    ),

    /*                       */
    pipeMap(
      /*                               */
      flatMap((stringOrProps) =>
        fromCondition(
          typeof stringOrProps === "string",
          stringOrProps as string,
          stringOrProps as OcSheetV1Props,
        ),
      ),

      /*                        */
      map((sheetId) => {
        const sheetInstance = document.querySelector<HTMLOcSheetV1Element>(`#${sheetId}`);
        if (sheetInstance) return next(sheetId);
        log.warn("sheet instance", sheetId, "not found, can not create with id only");
      }),

      /*                      */
      mapError((sheetProps) => {
        log.info("sheet props found, open with props", sheetProps);
        create({ ...sheetProps, open: true });
      }),
    ),
  );
}

/**
 *
 *
 */
export function useQueryParam(): void {
  if (!toggle.get("oc_sheet_v1_use_query_param", true)) {
    /*                           */
    if (import.meta.env.DEV)
      log.info("query param integration is disabled by toggle: oc_sheet_v1_use_query_param");
    return;
  }

  if (import.meta.env.DEV) log.info("initialize query param processing for oc-sheet-v1");
  onLoad.sub(initQueryParams, { once: true });
}
